export default {"src":"/_next/static/image/public/images/ic_dropdown_arrow_white.ff2c1af5b4e513500f5066d0ec897379.svg","height":8,"width":12};